import { FormattedMessage } from 'dibs-react-intl';

export const ringSize = (
    <FormattedMessage id="pdp.swatchSelector.ringSize" defaultMessage="Ring Size" />
);
